import React, { useEffect } from "react";
import { Project } from "../types";
import { handleHashScroll } from "../utils/scrollToSection";
import SEO from "../components/SEO";
import ProjectsSection from "../components/ProjectsSection"; // Reusing the ProjectsSection component

interface ProjectsPageProps {
  projects: Project[];
}

const ProjectsPage: React.FC<ProjectsPageProps> = ({ projects }) => {
  useEffect(() => {
    // Only handle hash scroll if there's actually a hash in the URL
    const hash = window.location.hash;
    if (hash && hash !== "#projects-page") {
      handleHashScroll();
    } else {
      // If no hash or just the default hash, scroll to top
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, []);

  return (
    <>
      <SEO
        title="Projects - Hardik Butani | Backend Developer Portfolio"
        description="Explore my portfolio of backend development projects including Node.js applications, REST APIs, microservices, and cloud solutions. See how I solve real-world problems with modern technologies."
        keywords="Backend Projects, Node.js Projects, API Development, Microservices, AWS Projects, Database Design, REST APIs, GraphQL, MongoDB, PostgreSQL, Docker, Kubernetes, Portfolio Projects, Software Development"
        url="/projects"
        type="website"
        tags={[
          "Projects",
          "Backend Development",
          "Node.js",
          "API Development",
          "Microservices",
          "AWS",
          "Portfolio",
        ]}
      />

      <section
        className="projects-page-section section-padding"
        id="projects-page"
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-12">
              <div className="section-header text-center mb-5">
                <h2 className="section-title">My Projects</h2>
                <p className="section-subtitle">
                  Here are some of the projects I've worked on. Each project
                  represents different challenges and technologies I've used to
                  solve real-world problems.
                </p>
              </div>
              <ProjectsSection projects={projects} />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ProjectsPage;
